'use client'

import { useTranslation } from 'react-i18next'
import { Link, useRouter } from '@tanstack/react-router'
import { Button, Flex, Heading, Text, VStack } from '@chakra-ui/react'
import { ArrowLeft, Home, LogOut, ShieldBan } from 'lucide-react'
import { AppCard, config, useAuthStore } from '@/shared'

export function ForbiddenPage() {
  const { t } = useTranslation()
  const router = useRouter()

  const { clearUser } = useAuthStore()

  const handleLogout = () => {
    clearUser()
    localStorage.clear()

    window.location.href = `${config.SSO_LOGOUT_URL}?client_id=${config.SSO_CLIENT_ID}&post_logout_redirect_uri=${window.location.origin + '/auth/entry'}`
  }

  return (
    <Flex
      align="center"
      justify="center"
      minH="min(70vh, 560px)"
      p={{ base: 4, md: 8 }}
      bg="bg"
    >
      <AppCard.Root maxW="440px" w="full">
        <AppCard.Body p={{ base: 6, md: 8 }}>
          <VStack gap={5} align="stretch" textAlign="center">
            <Flex justify="center" color="primary.fg">
              <ShieldBan size={40} strokeWidth={1.5} aria-hidden />
            </Flex>
            <Text
              fontSize="4xl"
              fontWeight="bold"
              lineHeight={1}
              color="primary.fg"
              letterSpacing="-0.02em"
            >
              {t('forbidden.code')}
            </Text>
            <Heading size="lg" fontWeight="bold" color="fg">
              {t('forbidden.title')}
            </Heading>
            <Text fontSize="sm" color="fg.muted" lineHeight={1.6}>
              {t('forbidden.description')}
            </Text>
            <Flex
              gap={3}
              flexDir={{ base: 'column', sm: 'column' }}
              justify="center"
              pt={2}
            >
              <Button
                w="full"
                gap={2}
                variant="outline"
                borderRadius="md"
                borderColor="border"
                color="fg"
                _hover={{ bg: 'bg.subtle' }}
                onClick={() => router.history.back()}
              >
                <ArrowLeft size={16} />
                {t('forbidden.back')}
              </Button>
              <Link to="/" style={{ textDecoration: 'none' }}>
                <Button
                  w="full"
                  gap={2}
                  bg="primary.solid"
                  color="white"
                  borderRadius="md"
                  _hover={{ opacity: 0.85 }}
                  _active={{ opacity: 0.7 }}
                >
                  <Home size={16} />
                  {t('forbidden.home')}
                </Button>
              </Link>
              <Button
                w="full"
                gap={2}
                variant="ghost"
                borderRadius="md"
                color="fg.muted"
                _hover={{ bg: 'bg.subtle', color: 'fg' }}
                onClick={handleLogout}
              >
                <LogOut size={16} />
                {t('forbidden.logout')}
              </Button>
            </Flex>
          </VStack>
        </AppCard.Body>
      </AppCard.Root>
    </Flex>
  )
}
